
import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Guide } from "@/types/guides";
import { Session } from "@supabase/supabase-js";
import { supabase } from "@/integrations/supabase/client";
import { GuideDownloadForm } from "./GuideDownloadForm";

interface GuideDownloadHandlerProps {
  session: Session | null;
}

export function GuideDownloadHandler({ session }: GuideDownloadHandlerProps) {
  const [downloadFormGuide, setDownloadFormGuide] = useState<Guide | null>(null);

  const handleDownload = (e: React.MouseEvent, guide: Guide) => {
    e.preventDefault();
    
    if (!guide.download_url) {
      toast.error("Download not available", {
        description: "This guide is not available for download yet."
      });
      return;
    }

    if (session?.user) {
      window.open(guide.download_url, '_blank');
      
      // For authenticated users, we know their information from their profile
      supabase.from('guide_downloads').insert({
        guide_id: guide.id,
        user_id: session.user.id,
        first_name: session.user.user_metadata.first_name || "User",
        last_name: session.user.user_metadata.last_name || "Unknown",
        email: session.user.email || "",
        county: "Unknown", // Default value, could be fetched from profile if available
        newsletter_opt_in: false
      }).then(() => {
        toast.success("Download started", {
          description: "Your guide will download shortly."
        });
      });
    } else {
      setDownloadFormGuide(guide);
    }
  };

  return {
    handleDownload,
    downloadFormGuide,
    setDownloadFormGuide,
  };
}
